import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { DeviceType } from './types'

interface EditProps {
  device: DeviceType
  communities: {
    id: string
    name: string
  }[]
}

export default function Edit({ device, communities }: EditProps) {
  return (
    <>
      <Head title="Editing device" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Editing device</h1>

        <Form
          device={device}
          communities={communities}
          action={`/system/devices/${device.id}`}
          method="patch"
          submitText="Update Device"
        />

        <Link
          href={`/devices/${device.id}`}
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Show this device
        </Link>
        <Link
          href="/devices"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Back to devices
        </Link>
      </div>
    </>
  )
}
